import { createRequestActions } from "common/helpers/action";

export const initRegistriesPreview = createRequestActions("REGISTRIES.PREVIEW.INIT");
export const scrollRegistriesPreview = createRequestActions("REGISTRIES.PREVIEW.SCROLL");
export const searchRegistriesPreview = createRequestActions("REGISTRIES.PREVIEW.SEARCH");
export const filterRegistriesPreview = createRequestActions("REGISTRIES.PREVIEW.FILTER");

export const showDetailRegistriesPreview = createRequestActions("REGISTRIES.PREVIEW.SHOW_DETAIL");
